import { IconProps } from "./types";

export function StopIcon({ size = 24, className = "", ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      {...props}
    >
      <rect x="6" y="6" width="12" height="12" rx="1.5" />
    </svg>
  );
}
